import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Accordion, Icon, Segment } from "semantic-ui-react";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionReport } from "../../../app/util/breadcrumbOptions";
import ListBrokerReport from "./ListBrokerReport";
import BrokerFilter from "./BrokerFilter";
import BrokerFilterInfo from "./BrokerFilterInfo";

const DashboardBrokerReport: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    acordionBrokerFilter,
    changeStateAcordionBroker,
  } = rootStore.reportStore;

  document.title = "Consumo mensual por agente";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Consumo mensual por agente"
        sections={sectionReport}
      />
      <Segment className="accordionSegment">
        <Accordion>
          <Accordion.Title
            active={acordionBrokerFilter}
            onClick={() => changeStateAcordionBroker()}
          >
            <Icon name="dropdown" />
            {acordionBrokerFilter ? "Ocultar filtros" : "Ver filtros"}
          </Accordion.Title>
          <Accordion.Content active={acordionBrokerFilter}>
            <BrokerFilter />
          </Accordion.Content>
          <Accordion.Content active={!acordionBrokerFilter}>
            <BrokerFilterInfo />
          </Accordion.Content>
        </Accordion>

        <ListBrokerReport />
        <br />
      </Segment>
    </div>
  );
};

export default observer(DashboardBrokerReport);
